import { createPortal } from "react-dom";

export default function Portal(props: { children: JSX.Element }) {
  return createPortal(
    props.children,
    document
      .querySelector("iframe")
      ?.contentDocument?.querySelector(".frame-root") ??
      document.getElementById("root") ??
      document.body
  );
}
